import Vue from 'vue'
import axios from 'axios'
import pinia from '@/store/'
import { useAppStore } from '@/store/modules/app'
import { useUserStore } from '@/store/modules/user'

import { ElLoading, ElMessage } from 'element-plus'
import { storeToRefs } from 'pinia'
import i18n from '@/i18n'
import router from '@/router'
const env = process.env.NODE_ENV

const { t, te } = i18n.global

let loadingInstance

//const store = useAppStore(pinia);
const requestConf = (config) => {
  const { token } = useUserStore()
  const { event, openid } = useAppStore()

  //if (token) config.headers['Authorization'] = `Bearer ${token}`
  if (event && event.ID) {
    if (event.Track) {
      config.params = Object.assign(config.params || {}, { i: event.Track })
    } else {
      config.params = Object.assign(config.params || {}, { v: event.ID })
    }
  }
  if (token) {
    config.params = Object.assign(config.params || {}, { uid: token })
  }
  if (openid) {
    config.params = Object.assign(config.params || {}, { openid: openid })
  }
  if (config.loading) {
    loadingInstance = ElLoading.service({
      lock: true,
      background: 'rgba(255, 255, 255, 0.6)',
      customClass: 'axios-loading',
    })
  }
  return config
}

const handleData = async ({ config, data, status = 0, statusText, headers }) => {
  if (loadingInstance) loadingInstance.close()
  let code = data ? data['ret'] : -1
  if (code == 0) {
    if (headers && headers['refresh-token']) {
      console.log(`refresh-token ${headers['refresh-token']}`)
      const userStore = useUserStore()
      const { setToken } = userStore
      setToken(headers['refresh-token'])
    }
    return data
  }
  if (code === 599900) {
    //const router = useRouter();
    console.log('router', router)
    router.replace({ name: 'Login' })
  } else {
    if (code == 510009) {
      ElMessage({
        message: data.data.message || '注册已截止',
        type: 'error',
      })
      return
    }
    if (!(code === 510699)) {
      ElMessage({
        message: te('error.' + data.ret) ? t('error.' + data.ret) : data.msg,
        type: 'error',
      })
    }
  }
  return Promise.reject(data)
}

const handleBlobData = async ({ data, status, statusText, headers }) => {
  if (loadingInstance) loadingInstance.close()
  var contentType = headers['content-type']
  var contentDisposition = headers['content-disposition']
  var filename = ''
  if (contentDisposition) {
    var match = contentDisposition.match(/filename\*=(.+)$/i)
    if (match) {
      var encodedFilename = match[1]
      // 去除前缀
      var prefix = "utf-8''"
      if (encodedFilename.startsWith(prefix)) {
        encodedFilename = encodedFilename.substring(prefix.length)
      }
      // 解码
      filename = decodeURIComponent(escape(encodedFilename))
    }
  }
  filename = decodeURIComponent(filename)
  if (status == 200 && contentType != 'application/json') {
    return { data: data, filename }
  }
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsText(data)
    reader.onload = () => {
      handleData({
        data: reader && reader.result ? JSON.parse(reader.result.toString()) : { ret: 500000, msg: 'Request Error' },
        status,
        statusText,
      })
        .then((res) => {
          reject(res)
        })
        .catch((ex) => {
          reject(ex)
        })
    }
  })
}
const instance = axios.create({
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
  },
  baseURL: window.baseURL || '',
})

instance.interceptors.request.use(requestConf, (error) => {
  return Promise.reject(error)
})

instance.interceptors.response.use(
  (response) => {
    if (response && response.request.responseType == 'blob') {
      return handleBlobData(response)
    } else {
      return handleData(response)
    }
  },
  (error) => {
    const { response = {} } = error
    if (response && response.request.responseType == 'blob') {
      return handleBlobData(response)
    } else {
      return handleData(response)
    }
  }
)
export function download(config) {
  config.responseType = 'blob'
  config.loading = true
  return new Promise((resolve, reject) => {
    instance
      .request(config)
      .then(({ data, filename }) => {
        const blob = new Blob([data])
        console.log('filename', filename)
        //const fileName = filename + '.' + contentType
        let URL = window.URL || window.webkitURL
        let bloburl = URL.createObjectURL(blob)
        let anchor = document.createElement('a')
        if ('download' in anchor) {
          anchor.style.visibility = 'hidden'
          anchor.href = bloburl
          anchor.download = filename
          document.body.appendChild(anchor)
          let evt = document.createEvent('MouseEvents')
          evt.initEvent('click', true, true)
          anchor.dispatchEvent(evt)
          document.body.removeChild(anchor)
        } else if (window.navigator.msSaveBlob) {
          window.navigator.msSaveBlob(blob, filename)
        } else {
          location.href = bloburl
        }
        resolve({ ret: 0 })
      })
      .catch((ex) => {
        console.log('------------------------------')
        reject(ex)
      })
  })
}

export default instance
